import {
    OptionPicker,
    createOptionPicker,
} from '@vfde-brix/ws10/option-picker';
import { HtmlId } from '../enums/elementId';
import { createComponentById } from '@vfde-brix/ws10/core';

/**
 * Creates a WS10 Option Picker component.
 */
export const mountOptionPicker = (id: HtmlId, onChange: (value: string) => void) =>
    createComponentById(createOptionPicker, id, {
        onChange: ({ target }) => {
            if (target && target instanceof HTMLInputElement) {
                onChange(target.value);
            }
        },
    });

/**
 * Disables all options if not enabled, otherwise enables all options
 */
export const setOptionPickerState = (optionPicker: OptionPicker | null, isEnabled: boolean) =>
    isEnabled ? optionPicker?.enableAllOptions() : optionPicker?.disableAllOptions();
